import { UPDATE_SEARCHTDATA_DUNONHANVAY } from "../../actions/DuNoNhanVay/actionTypes";

const initialState = {
  dateFrom: "01/01/2001",
  dateTo: "01/01/4000",
  tenChuNo: "",
  nhanvien: "",
  mataisan: "",
  trangthai: 0,
  sotienvay: "",
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchDuNoNhanVay = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DUNONHANVAY:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDuNoNhanVay;
